import { useFormik } from 'formik';
import validator from 'validator';
import * as Yup from 'yup';

const PracticeContactInfoSchema = Yup.object().shape({
  practiceEmail: Yup.string().email('Invalid email address').required('Email is required'),
  practicePhone: Yup.string().test('practicePhone', '', (value, validationContext) => {
    const { createError } = validationContext;

    if (value === undefined || value === null || value === '') {
      return true; // Phone is not required
    }
    if (!validator?.isMobilePhone(value)) {
      return createError({ message: 'Please provide a correct phone number.' });
    }

    return true;
  })
});

export default function usePracticeContactInfoFormik(contactInfo = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      practiceEmail: contactInfo?.email || '',
      practicePhone: contactInfo?.phone || '',
      twilioPhone: contactInfo?.twilio_phone || '',
      fax: contactInfo?.fax || ''
    },
    enableReinitialize: true,
    validationSchema: PracticeContactInfoSchema,
    onSubmit
  });

  return formik;
}
